import Vue from "vue";
import vSelect from "vue-select";
import VueResize from "vue-resize";
import VueGtag from "vue-gtag";
import { isIOS, isMacOs, isMobileOnly } from "mobile-device-detect";

import { store } from "./store";
import { router } from "./router";
import { api } from "./services/api.service";
import Alert from "./components/Alert";
import SmoothReflow from "./components/SmoothReflow";
import Spinner from "./components/Spinner";

import "bootstrap/dist/css/bootstrap.css";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-resize/dist/vue-resize.css";

import App from "./App";
import "./registerServiceWorker";

Vue.config.productionTip = false;

Vue.prototype.$http = api;

Vue.component("v-select", vSelect);
Vue.component("Alert", Alert);
Vue.component("SmoothReflow", SmoothReflow);
Vue.component("Spinner", Spinner);

Vue.use(VueResize);

Vue.use(
  VueGtag,
  {
    bootstrap: false,
  },
  router
);

Vue.mixin({
  computed: {
    $isIOS() {
      return isIOS;
    },
    $isMacOS() {
      return isMacOs;
    },
    $isMobile() {
      return isMobileOnly;
    },
    $isDevEnv() {
      return process.env.NODE_ENV === "development";
    },
    $disableMap() {
      return this.$isDevEnv && process.env.VUE_APP_DISABLE_MAP === "true";
    },
    $liveUpdateMap() {
      if (this.$isDevEnv) {
        return process.env.VUE_APP_LIVE_UPDATE_MAP === "true";
      }
      return true;
    },
    $showTour() {
      return this.$isDevEnv && process.env.VUE_APP_SHOW_TOUR === "true";
    },
  },
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
